import '../assets/style/Walls.css'
import { useEffect, useState } from "react";
import { WallsItem } from "../Component/Walls/Item.Walls";
import { socket } from "../components/Containers/MainContainer";
import Skeleton from "react-loading-skeleton";
import { showAdjoeModal } from "../components/utils";

export const WallsContainer = (props) => {
    useEffect(function () {
        document.querySelectorAll('.tippy-popper').forEach(x => x.remove())
        window.scrollTo(0, 0)
    }, [])

    const [promotedOffers, setPromotedOffers] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])

    useEffect(() => {
        setTimeout(() => {
            socket.emit('emitOfferWalls');
        }, 1000)
        socket.on('activityOfferWalls', (data) => {
            setPromotedOffers([
                {
                    background: "linear-gradient(336.89deg, rgb(19, 23, 57) -26.71%, rgb(103, 88, 209) 107.56%)",
                    canUse: true,
                    id: 15,
                    img: "adjoe.png",
                    increase: "+50%",
                    levelRequired: 0,
                    name: "adjoe",
                    type: "OfferWall"
                },
                ...data.offerwallsPack])
            socket.off('activityOfferWalls')
        })
    }, [])

    return (
        <div className="promoted-small-offer-container">
            <h2 className="promoted-small-offer-container-title">{props.title}</h2>
            <div className="walls-grid">
                {promotedOffers.map((item, i) => {
                    if (item.type == undefined) {
                        return <Skeleton key={i} style={{ height: '172px', borderRadius: '8px' }} />
                    }
                    if (item.type.toLowerCase() == props.for) {
                        return (
                            <div key={i} onClick={async () => {
                                if (item.canUse == false) {
                                    window.dispatchEvent(new CustomEvent('showInfoModal', { detail: { title: 'is not yet available for you', description: `${item.unavDescription}`, image: `https://paidcash.co/assets/img/partners/${item.img}`, type: 'small', click: () => { } } }))
                                } else {
                                    if (item.name.toLowerCase() == 'adjoe') {
                                        if (typeof window.PaidCashChannel !== 'undefined' && window.PaidCashChannel.postMessage) {
                                            window.PaidCashChannel.postMessage('adjoe');
                                        } else {
                                            showAdjoeModal();
                                        }
                                    } else {
                                        window.dispatchEvent(new CustomEvent('handleWallsUp', { detail: { name: item.name } }))
                                    }
                                }
                            }}>
                                <WallsItem
                                    image={`/assets/img/partners/${item.img}`}
                                    title={item.name}
                                    increase={item.increase}
                                    locked={props.logged == false ? false : item.canUse == false ? true : false}
                                    lockedText={"Not Yet Available For You"}
                                    background={item.background}
                                />
                            </div>
                        )
                    }
                    return null
                })}
            </div>
        </div>
    )
}
